import { useEffect } from 'react';
import { displayNotify } from '../services/Notifications/NotificationServices';
import { sseURL } from '../config';
import { isDebugMode } from '../utils/isDebugMode';

interface SSENotification {
  title: string;
  text: string;
}

export function useSSENotifications() {
  const debugMode = isDebugMode()

  useEffect(() => {
    if (!debugMode) {
      return
    }

    const eventSource = new EventSource(sseURL)

    eventSource.onmessage = (event) => {
      try {
        const data: SSENotification = JSON.parse(event.data)

        displayNotify({
          status: "info",
          title: data.title,
          description: data.text,
        })
      } catch (error) {
        console.error('Failed to parse SSE message', error)
      }
    }

    eventSource.onerror = (error) => {
      console.error('SSE error', error)
    }

    return () => {
      eventSource.close()
    }
  }, [debugMode])
}